import styled from "styled-components";
import { Container } from "../../../components/navbar/Nav.styles";
import AboutIcon from "../../../assets/Group33.svg";
import VisionIcon from "../../../assets/Group34.svg";
import MissionIcon from "../../../assets/Group36.svg";

const AboutSession = () => {
  return (
    <Container>
      <CaptionText>About Us</CaptionText>
      <CardWrapper>
        <h1>
          Let’s tell <br /> you about us
        </h1>
        <CardContainer>
          <CardBody>
            <div>
              <img
                width="96px"
                height="48px"
                src={AboutIcon}
                alt="icon-about"
              />
            </div>
            <h2>About us</h2>
            <p>
              Invest–Trust Limited aims to be a timely provider of investment
              products and services that incorporates global best practices and
              modern technology in delivering absolute quality.
            </p>
          </CardBody>
          <CardBody outline="outline">
            <div>
              <img
                width="96px"
                height="48px"
                src={VisionIcon}
                alt="icon-about"
              />
            </div>
            <h2>Our Vision</h2>
            <p>
              To be a financially viable community that is committed to
              satisfying customer’s needs by offering diverse investment offers
              that are technologically driven.
            </p>
          </CardBody>
          <MissionCard>
            <div>
              <img
                width="96px"
                height="48px"
                src={MissionIcon}
                alt="icon-about"
              />
            </div>
            <h2>Our Mission</h2>
            <p>
              To provide positive investment opportunities for all our clients.
              To create and maintain a professional environment that fosters the
              confidence of all stakeholders. To embrace technology as a means
              to providing lasting investment solutions.
            </p>
          </MissionCard>
        </CardContainer>
      </CardWrapper>
    </Container>
  );
};

export default AboutSession;

export const CaptionText = styled.h1`
  margin-top: 0rem;
  text-align: right;
  font-size: 9.75rem;
  font-weight: 900;
  line-height: 164px;
  color: ${({ theme }) => theme.colors.caption};

  @media screen and (max-width: 991px) {
    font-size: 88px;
    text-align: center;
    line-height: 88px;
  }
  @media screen and (max-width: 579px) {
    text-align: center;
  }
`;

export const CardWrapper = styled.div`
  transform: translateY(-150px);

  h1 {
    margin-bottom: 6rem;
    font-size: 2rem;
    font-weight: 700;
    color: ${({ theme }) => theme.colors.secondary};
    font-family: "Futura";
    line-height: 40px;

    @media screen and (max-width: 991px) {
      transform: translateY(4rem);
      text-align: center;
    }
    @media screen and (max-width: 579px) {
      transform: translateY(6rem);
      text-align: center;
    }
  }
`;
export const CardContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 22px;

  @media screen and (max-width: 991px) {
    grid-template-columns: 1fr;
    gap: 6rem;
    margin-top: 10rem;
  }
  @media screen and (max-width: 579px) {
    margin-top: 12rem;
    //   border: 10px solid teal;
  }
`;

export const CardBody = styled.div`
  background: ${(props) => (props.outline ? "#FFF7E8" : "#E9E9FC")};
  border-radius: 24px;
  display: flex;
  flex-direction: column;
  align-items: center;

  img {
    max-width: 100%;
  }

  text-align: center;

  div {
    transform: translateY(-70px);
    display: flex;
    justify-content: center;
    align-items: center;
    background: #ffffff;
    box-shadow: 0px 8px 16px rgba(0, 0, 0, 0.16);
    border-radius: 16px;
    width: 136px;
    height: 136px;
  }
  h2 {
    transform: translateY(-4.5rem);
    font-family: "Futura";
    font-size: 2rem;
    color: ${({ theme }) => theme.colors.body};
  }

  p {
    transform: translateY(-5.8rem);
    margin-top: 0;
    font-weight: 400;
    font-size: 20px;
    padding: 0rem 1.875rem;
    margin-bottom: -3rem;
  }
`;

export const MissionCard = styled(CardBody)`
  background: #ffdce2;
`;
